import { useStepsContext } from '@/providers/pi-multi-step-form/StepsContext';
import StepContainer from './step-container';
import Alert from '@/components/pages/alert';
import clsx from 'clsx';
import { Trophy } from '@/components/pages/icons';

export default function WereYouInjured() {
  const {
    onWereYouInjuredChange,
    wereYouInjuredValue,
    nextStep,
    register,
    trigger,
    errors,
    errorClassNames,
  } = useStepsContext();

  const onContinue = () => {
    nextStep();
  };

  const [wereYouInjured] = wereYouInjuredValue;

  const isValid = wereYouInjured && !errors?.lead?.contact?.details;

  return (
    <StepContainer
      title="Were you injured?"
      subtitle="This helps us custom-build your recovery plan, including doctors and medical services."
      onSubmit={onContinue}
      buttonDisabled={!isValid}
      buttonLabel="Next"
    >
      <>
        <div className="grid grid-cols-1 @lg:grid-cols-2 gap-2 mb-4">
          <label
            className={`flex items-center justify-center rounded-full border  text-brand-accent transition-colors cursor-pointer text-base font-semibold leading-[100%] min-h-12 w-full ${wereYouInjured === '8' ? 'bg-brand-accent text-white' : 'border-brand-accent bg-transparent hover:bg-black/10 '}`}
          >
            Yes{' '}
            <input
              name="injured"
              type="radio"
              value="8"
              className="sr-only"
              onChange={onWereYouInjuredChange}
              checked={wereYouInjured === '8'}
            />
          </label>
          <label
            className={`flex items-center justify-center rounded-full border  text-brand-accent transition-colors cursor-pointer text-base font-semibold leading-[100%] min-h-12 w-full ${wereYouInjured === '9' ? 'bg-brand-accent text-white' : 'border-brand-accent bg-transparent hover:bg-black/10 '}`}
          >
            No{' '}
            <input
              name="injured"
              type="radio"
              value="9"
              className="sr-only"
              onChange={onWereYouInjuredChange}
              checked={wereYouInjured === '9'}
            />
          </label>
        </div>

        <textarea
          placeholder="Tell us what happened"
          className={clsx(
            'bg-white border-0 w-full ring-inset ring-1 ring-black/20 rounded-lg p-4 text-brand-default focus:ring-brand-accent focus:outline-none mb-8 focus:shadow-brand-input transition-all duration-300',
            errors?.lead?.contact?.details && errorClassNames
          )}
          {...register?.('lead.contact.details')}
          onBlur={() => trigger('lead.contact.details')}
        ></textarea>

        <Alert icon={<Trophy />}>
          <p>
            JLG has helped <b>80,000+</b> clients, and won $2+ billion in settlements for them.
          </p>
          <p className="italic">
            “Jordan was great for me and my case. I’d recommend her to everyone.” -Erica T.
          </p>
        </Alert>
      </>
    </StepContainer>
  );
}
